<template>
  <div class="">
    <static-tabs-wallet active="registries"> </static-tabs-wallet>
    <registries> </registries>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Registries from "@/components/wallet/registries/index.vue";
import StaticTabsWallet from "@/components/wallet/static-tabs.vue";
export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  created() {
    this.notifyQueue({
      text: "Portafoglio",
      path: "",
      level: 1,
    });
    this.notifyQueue({
      text: "Clienti",
      path: "registries.index",
      level: 2,
    });
  },
  props: {
    msg: String,
  },
  components: {
    Registries,
    StaticTabsWallet,
  },
};
</script>
